module.exports = __webpack_public_path__ + "static/drown-7d21c07e7168cb6c5893b3963a676bed.png";